/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Frontrow_Booked_BadgeInputs */

const en_scene_frontrow_booked_badge = /** @type {(inputs: Scene_Frontrow_Booked_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booked`)
};

/**
* | output |
* | --- |
* | "Booked" |
*
* @param {Scene_Frontrow_Booked_BadgeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_frontrow_booked_badge = /** @type {((inputs?: Scene_Frontrow_Booked_BadgeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Frontrow_Booked_BadgeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_frontrow_booked_badge(inputs)
});